import React from 'react'
import { StarsSection, Link, Image } from 'newComponents'
import classNames from 'classnames'
import '../../../styles/trajectory.scss'
import starsBg from '../../../images/webinars/stars_bg.jpg'
import './styles.scss'

const FutureWebinarPanel = (props) => {
  const { futureWebinar, isActive } = props
  const { data, uid } = futureWebinar

  const { category, date, recording_length: length, speakers, subtitle, time, title } = data

  const isSpeakerAvailable = speakers?.length > 0
  return (
    <Link
      to={uid}
      style={{ textDecoration: 'none' }}
      className={isActive ? 'future-webinar-active' : 'future-webinar-inactive'}
    >
      <div className="future-webinar-panel" style={{ animation: 'fade 1s ease-in-out' }}>
        <StarsSection
          className={classNames('future-webinar-stars-section', {
            'future-webinar-stars-section-full-width': !isSpeakerAvailable
          })}
          stars={starsBg && starsBg.childImageSharp && starsBg.childImageSharp.fluid}
        >
          {category && <p className="future-webinar-category">{category}</p>}
          <div className="future-webinar-data-container">
            {title && <h1 className="future-webinar-title">{title.text}</h1>}
            {subtitle && <p className="future-webinar-subtitle">{subtitle.text}</p>}
            <p className="future-webinar-datetext">
              {date} {time?.text ? `| ${time.text}` : ''}
            </p>
          </div>
          <div className="future-webinar-button-container">
            <button type="button" className="button is-large is-primary border-radius-2">
              LEARN MORE
            </button>
          </div>
        </StarsSection>

        {isSpeakerAvailable && (
          <div className="future-webinar-speakers-container">
            <div className="future-webinar-speakers">
              <h3 className="">{speakers.length === 1 ? 'Speaker' : 'Speakers'}</h3>
              {speakers.map((panelist) => {
                const { avatar, name, role, logo } = panelist
                const formattedProfileImg = avatar?.publicURL || avatar
                return (
                  <div className="future-webinar-speaker" key={name.text}>
                    <div className="speaker-image-container">
                      <Image
                        image={formattedProfileImg}
                        alt={name}
                        className="speaker-image"
                        placeholder="rgba(255,0,0,0.0)"
                      />
                    </div>
                    <div className="future-title">
                      <h4 className="speaker-info-container">{name.text}</h4>
                      <p className="speaker-title">{role.text}</p>
                      <Image image={logo} alt={logo.url} className="speaker-company-logo" />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </Link>
  )
}

export default FutureWebinarPanel
